import '.c6{position:relative;}.ssr-plugin'
import '.a0{width:100%;}.ssr-plugin'
import '.g4{min-height:200px;}.ssr-plugin'
import '.j{display:flex;}.ssr-plugin'
import '.v{flex-direction:column;}.ssr-plugin'
import '.k{justify-content:center;}.ssr-plugin'
import '.b0{align-items:flex-start;}.ssr-plugin'
import '.a2{padding:2rem;}.ssr-plugin'
import '.e1{background:var(--shades-white);}.ssr-plugin'
import '.h{overflow:hidden;}.ssr-plugin'
import '.d{position:absolute;}.ssr-plugin'
import '.ii{top:50%;}.ssr-plugin'
import '.ij{right:1rem;}.ssr-plugin'
import '.ik{transform:translateY(-50%);}.ssr-plugin'
import '.il{width:120px;}.ssr-plugin'
import '.im{height:120px;}.ssr-plugin'
import '.in{z-index:0;}.ssr-plugin'
import '.r{align-items:center;}.ssr-plugin'
import '.hj{z-index:1;}.ssr-plugin'
import '.b1{gap:0.5rem;}.ssr-plugin'
import '.io{max-width:calc(100% - 140px);}.ssr-plugin'
import { Style, styled } from 'inlines'
import { Title } from '@app/components/core/typography/Title'
import { Text } from '@app/components/core/typography/Text'
import { Image } from '@app/components/core/image/Image'

export interface StatisticProps {
  number: string
  subtitle: string
  illustration?: string
  style?: Style
}

export const Statistic = ({
  number,
  subtitle,
  illustration,
  style,
}: StatisticProps) => {
  return (
    <styled.div className="c6 a0 g4 j v k b0 a2 e1 h"
      data-testid="statistic"
      style={{
        ...style,
      }}
    >
      {/* Background Illustration - Right Aligned */}
      {illustration && (
        <div className="d ii ij ik il im in j r k"
        >
          <Image
            src={illustration}
            alt={`${subtitle} illustration`}
            style={{
              width: '100%',
              height: '100%',
              objectFit: 'contain',
            }}
          />
        </div>
      )}

      {/* Content - Left Aligned with higher z-index */}
      <div className="c6 hj j v b0 b1 io"
      >
        {/* Bold Number */}
        <Title.H1
          style={{
            fontSize: '4rem',
            fontWeight: '700',
            lineHeight: '100%',
            margin: 0,
            color: 'var(--primary-blue)',
            fontFamily: 'FunnelDisplay',
          }}
        >
          {number}
        </Title.H1>

        {/* Subtitle */}
        <Text.Medium
          style={{
            color: 'var(--primary-blue)',
            opacity: 0.8,
            margin: 0,
            lineHeight: '140%',
            fontWeight: '400',
          }}
        >
          {subtitle}
        </Text.Medium>
      </div>
    </styled.div>
  )
}
